import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { pdfjs } from "react-pdf"; // This is for react-pdf, not react-pdf-viewer

// Setting the worker source for react-pdf (not used here but good to include if mixing libraries)
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

const PDFViewer = ({ pdfUrl }) => {
    console.log("pdfUrl: ", pdfUrl);
    return (
        <div style={{ height: "100vh", width: "100%" }}>
            {/* PDF.js worker for react-pdf-viewer */}
            <Worker workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.mjs`}>
                <Viewer fileUrl={pdfUrl} />
            </Worker>
        </div>
    );
};

export default PDFViewer;
